import PDFImg from "assets/img/PDFImg.png";
import theme from "theme/theme";
import React from "react";
import {Box} from "@mui/material";

interface FilePreviewProps {
  id?: string;
  itemSx: any;
  onClick: () => void;
  withBorder?: boolean;
  title?: string;
}

function PDFPreview(props: FilePreviewProps) {
  const {id = "n", itemSx, onClick, withBorder, title = ""} = props;
  return (
    <Box
      title={title}
      id={`pdf-preview-${id}`}
      style={{
        display: "grid",
        placeItems: "center",
        minWidth: 64,
        height: 64,
        backgroundColor: theme.palette.background.swiftDefault,
        borderRadius: 2,
        ...(withBorder && {
          border: `1px solid ${theme.palette.neutral.light}`,
        }),
        ...itemSx
      }}
      className="file-preview-item"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <img
        src={PDFImg}
        style={{alignSelf: "center"}}
        alt={"PDF"}
      />
    </Box>
  )
}

export default PDFPreview;